import type { JobLog } from '@techgitter/contracts';

/**
 * True when the job has at least one non-deleted Diagnostics job-log entry.
 *
 * Quote creation seeds the consolidated description from the latest
 * Diagnostics job-log, so the Add-Quote flow warns the tech when none
 * exists. Only SM4RT-native job logs carry the `diagnostics` type —
 * RepairShopr comments are excluded by checking `logs` rather than the
 * merged display entries.
 */
export function hasDiagnosticsLog(logs: JobLog[]): boolean {
  return logs.some((l) => l.type === 'diagnostics' && l.status !== 'deleted');
}
